import React from "react";

interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
}

const SearchBox: React.FC<SearchBoxProps> = ({ value, onChange }) => {
  return (
    <div className="input-group search-orders">
      <input
        type="text"
        className="form-control"
        placeholder="Search Orders"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <button className="btn btn-primary">
        <i className="bi bi-search"></i>
      </button>
    </div>
  );
};

export default SearchBox;